import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import logo from "../../../assets/images/logo-colored.png";
import "./MerchantFormHeader.scss";

const MerchantFormHeader = ({ hideLogin = false }) => {
  // Use Auth0 React SDK hook
  const { loginWithRedirect } = useAuth0();

  const handleLogin = (e) => {
    e.preventDefault(); // Prevent default anchor navigation behavior
    loginWithRedirect({
      appState: {
        returnTo: "/dashboard",
      },
    });
  };

  return (
    <header className="merchant-form-header">
      <div className="container">
        <div className="row align-items-center">
          {/* Left side: Logo section */}
          <div className="col-5">
            {/* Link to homepage or top of page */}
            <a href="#" aria-label="Homepage">
              {/* Display company logo */}
              <img src={logo} alt="Company Logo" />
            </a>
          </div>

          {/* Right side: Login prompt and link - Conditionally hidden */}
          {!hideLogin && (
            <div className="col-7">
              <div className="header-right-section text-end">
                {/* Inform user if they already have an account */}
                <span>Already have an account?</span>

                {/* Login link triggers the Auth0 login method */}
                <a
                  href="#"
                  className="text-bold text-link"
                  onClick={handleLogin}
                >
                  Login
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default MerchantFormHeader;
